import { RefundRequest, RefundRequestComponentStatus } from "../../../common/types";

export function partiallyOrFullyRefunded(refundRequest: RefundRequest): boolean {
  return refundRequest.components.some(component => {
    return [RefundRequestComponentStatus.Processed, RefundRequestComponentStatus.Processing].includes(component.status);
  });
}
